/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import Compressor from 'compressorjs';
import { getFileFromMinio } from '../services/minio.service';

interface CompressorOptions {
  quality: number;
  success: (result: File) => void;
}

export async function compressImage(image: File): Promise<File> {
  return new Promise((resolve, reject) => {
    try {
      new Compressor(image, {
        quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
        success: (compressedResult: File) => {
          resolve(compressedResult);
          // compressedResult has the compressed file.
          // Use the compressed file to upload the images to your server.
        },
      } as CompressorOptions);
    } catch {
      reject(undefined);
    }
  });
}

export async function getFileType(url: string | undefined): Promise<string> {
  if (!url) return '';

  // Extract file extension from URL
  const fileName = url.substring(url.lastIndexOf('/') + 1);
  const extension = fileName.split('.').pop()?.toLowerCase() || '';

  // Simple MIME type mapping based on file extension
  const mimeTypes: Record<string, string> = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    svg: 'image/svg+xml',
    mp4: 'video/mp4',
    avi: 'video/x-msvideo',
    mov: 'video/quicktime',
    pdf: 'application/pdf',
    txt: 'text/plain',
    json: 'application/json',
    xml: 'application/xml',
    zip: 'application/zip',
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    ogg: 'audio/ogg',
  };

  return mimeTypes[extension] || 'application/octet-stream';
}

export async function getFile(fileName: string): Promise<string> {
  try {
    // Extract file extension from filename
    const extension = fileName.split('.').pop()?.toLowerCase() || '';

    // Simple MIME type mapping based on file extension
    const mimeTypes: Record<string, string> = {
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      webp: 'image/webp',
      svg: 'image/svg+xml',
      mp4: 'video/mp4',
      avi: 'video/x-msvideo',
      mov: 'video/quicktime',
      pdf: 'application/pdf',
      txt: 'text/plain',
      json: 'application/json',
      xml: 'application/xml',
      zip: 'application/zip',
      mp3: 'audio/mpeg',
      wav: 'audio/wav',
      ogg: 'audio/ogg',
    };

    return mimeTypes[extension] || 'application/octet-stream';
  } catch (error) {
    return '';
  }
}

export function convertUnixToISO(timestamp: number): string {
  return new Date(timestamp * 1000).toISOString();
}
